import React from 'react';

export const Icon = ({ name, showCircle = false }) => (
    <React.Fragment>
        {
            showCircle && (
                <div className="icon-background-container">
                    <div className={`background-circle svg-circle-${name}`} />
                </div>
            )
        }
        <div className={`icon svg-icon-${name}`} />
    </React.Fragment>
);
